function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.571 4.16v3.536H18.47c-1.648 0-1.956.79-1.956 1.929v2.531h3.925l-.523 3.965h-3.402v10.165h-4.098V16.12H9v-3.965h3.415v-2.92C12.415 5.849 14.491 4 17.518 4c1.446 0 2.692.107 3.053.16z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    height: 30,
    width: 30
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjMwIiB2aWV3Qm94PSIwIDAgMzAgMzAiIHdpZHRoPSIzMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMjAuNTcxNDQyNCA0LjE2MDcxNDQ4djMuNTM1NzE4NWgtMi4xMDI2ODExYy0xLjY0NzMyMzQgMC0xLjk1NTM1OTUuNzkwMTc5NTEtMS45NTUzNTk1IDEuOTI4NTczNzN2Mi41MzEyNTI5OWgzLjkyNDExMThsLS41MjIzMjIgMy45NjQyOTA1aC0zLjQwMTc4OTh2MTAuMTY1MTkwN2gtNC4wOTgyMTkydi0xMC4xNjUxOTA3aC0zLjQxNTE4MjZ2LTMuOTY0MjkwNWgzLjQxNTE4MjZ2LTIuOTE5NjQ2MzFjMC0zLjM4ODM5NjkgMi4wNzU4OTU0LTUuMjM2NjEzMzkgNS4xMDI2ODQ3LTUuMjM2NjEzMzkgMS40NDY0MzAzIDAgMi42OTE5Njc1LjEwNzE0Mjk4IDMuMDUzNTc1MS4xNjA3MTQ0OHoiLz48L3N2Zz4=";
export { SvgComponent as ReactComponent };


// WEBPACK FOOTER //
// ./src/assets/svg/icon-facebook.svg